import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { goalsCollection } from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import { timestamp } from '@/firebase/firebaseHelpers'
import * as DateHelper from '@/helpers/date'

// import state from './_state'
// import mutations from './_mutations'
// import actions from './_actions'
// import getters from './_getters'


// const tomorrowgoal = (goal) => goal.deadline && DateHelper.areEqual(goal.deadline.toDate(), midnightTomorrow())
// const deadlineAfterTomorrow = (goal) => goal.deadline && goal.deadline.toDate() > midnightTomorrow()
// const inProgressOrDoneToday = (goal) => !goal.done || (goal.doneOn && DateHelper.areEqual(goal.doneOn.toDate(), midnight()))

const inProgressOrDoneToday = (goal) => goal.progressPercent < 100 || (goal.doneOn && DateHelper.areEqual(goal.doneOn.toDate(), DateHelper.midnight()))

const goalDefaults = () => {
  return {
    title: '',
    subgoals: [],
    doneOn: null,
    deadline: null,
    max: 100,
    progressPercent: 0,
    progress: 0,
    status: 'active',
    lastProgressOn: null,
    createdAt: null
  }
}

export default {
  state: {
    goals: [],
  },
  getters: {
    templatedGoals: (state, getters) => _.filter(state.goals, (goal) => inProgressOrDoneToday(goal, getters) && goal.templateId),
    allGoals: (state) => state.goals,
    inProgressGoals: (state) => _.filter(state.goals, (goal) => inProgressOrDoneToday(goal) && goal.status === 'active'),
    pausedGoals: (state) => _.filter(state.goals, (goal) => inProgressOrDoneToday(goal) && goal.status === 'paused'),
    overdueGoals: (state, getters) => _.filter(getters.inProgressGoals, (goal) => goal.deadline && goal.deadline.toDate() < DateHelper.midnight()),
    soonGoals: (state, getters) => _.difference(_.filter(getters.inProgressGoals, (goal) => goal.deadline && !DateHelper.isCurrentMonth(goal.deadline.toDate()) && !DateHelper.isNextMonth(goal.deadline.toDate())), getters.overdueGoals),
    somedayGoals: (state, getters) => _.filter(getters.inProgressGoals, (goal) => !goal.deadline),
    thisMonthGoals: (state, getters) => _.difference(_.filter(getters.inProgressGoals, (goal) => goal.deadline && DateHelper.isCurrentMonth(goal.deadline.toDate())), getters.overdueGoals),
    nextMonthGoals: (state, getters) => _.difference(_.filter(getters.inProgressGoals, (goal) => goal.deadline && DateHelper.isNextMonth(goal.deadline.toDate())), getters.overdueGoals),
    goalsByDream: (state, getters) => (dream, done = false) => _.chain(done ? getters.allGoalsDone : getters.allGoals)
      .filter((g) => _.isEqual(g.dream, dream))
      .orderBy(['orderDream', 'createdAt'], ['asc', 'asc'])
      .value(),
  },
  actions: {
    bindGoals: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef('goals', goalsCollection.where('uid', '==', currentUserId()))
    }),
    ADD_GOAL (_, { goal }) {
      console.info('ADD_GOAL', goal)

      const newGoal = Object.assign(goalDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp()
      }, goal)

      const res = goalsCollection.add(newGoal)
      console.log(res)
    },
    async UPDATE_GOAL (_, { goal, updateFields }) {
      console.info('UPDATE_GOAL', goal, updateFields)
      goalsCollection.doc(goal.id).update(updateFields)
    },
    async DELETE_GOAL ({ commit }, { goal }) {
      const data = { goal: { ...goal} }

      console.info('DELETE_goal', goal)

      const reverse_detail = 'restore goal'
      const action = 'ADD_GOAL'
      const title = goal.title


      commit('SET_LAST_ACTION', { action, title, reverse_detail, data, time: new Date() })

      console.info('DELETE_GOAL', goal)
      goalsCollection.doc(goal.id).delete()
    },
  }
}
